<template>
  <div class="bg-white shadow rounded-lg p-3">
    <div class="lg:flex lg:items-center lg:justify-between">
      <!-- Left side -->
      <div class="flex-1 min-w-0">
        <div class="flex flex-1 flex-col pr-4 sm:truncate">
          <div
            class="font-bold leading-7 text-cool-gray-900 sm:leading-9 text-lg"
          >
            Related Order
          </div>
          <div
            v-for="relation in order.relations"
            :key="relation.orderNumber"
          >
            {{ relationType(relation) }}:
            <span v-if="relation.type !== 'Draft Warranty'">
              <a class="link" :href="relationLink(relation)">
                {{ relation.sourceOrderNumber }}
              </a>
              ({{ relation.orderTime | date }})
            </span>
            <span class="link" v-else v-html="relationLink(relation)"></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import dateFormatter from "@/mixins/dateFormatter";

export default {
  name: "RelatedOrder",
  filters: {
    date: dateFormatter.usDateTime,
  },
  props: {
    order: {
      type: Object,
      required: true,
    },
  },
  methods: {
    relationType(relation) {
      if (relation.type === "Draft Warranty") {
        return "Draft Warranty Order Pending";
      }
      return relation.type + " Order";
    },
    relationLink(relation) {
      if (relation.type === "Draft Warranty") {
        return relation.orderNumber;
      }
      return "/customers/orders/" + relation.sourceOrderNumber;
    },
  },
};
</script>
<style scoped>
.link {
  @apply ml-0 text-green-600 transition duration-150 ease-in-out;
}

.link:hover {
  @apply text-green-500 underline;
}
</style>
